module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (showImageActionsPanel) { ;
__p += '\n    <div class="actions-panel">\n        ';
 if (isEditable && timesUsed > 0) { ;
__p += '\n            <span class="no-delete pull-right" data-content="The Image is in use and cannot be deleted"></span>\n        ';
 } else if (isEditable) { ;
__p += '\n            <span class="delete pull-right" data-content="Delete Image forever"></span>\n        ';
 } else { ;
__p += '\n            <span class="delete pull-right disabled" data-content="You do not have permission to delete Images"></span>\n        ';
 } ;
__p += '\n\n        ';
 if (isEditable && isLocked) { ;
__p += '\n            <span class="no-detach pull-right" data-content="The Image is in use in the current Project and cannot be detached"></span>\n        ';
 } else if (isEditable) { ;
__p += '\n            <span class="detach pull-right" data-content="Detach Image"></span>\n        ';
 } else { ;
__p += '\n            <span class="detach pull-right disabled" data-content="You do not have permission to detach Images"></span>\n        ';
 } ;
__p += '\n\n    </div>\n';
 } ;
__p += '\n\n<div class="image-thumb">\n    <span class="helper"></span>\n    ';
 if (uploading) { ;
__p += '\n        <div class="image-placeholder">\n            <div class="progress-bar"></div>\n        </div>\n    ';
 } else { ;
__p += '\n        <img src="' +
__e( absoluteThumbUrl ) +
'" class="image">\n    ';
 } ;
__p += '\n</div>\n\n<div class="image-info">\n    <div class="js-name-editable-container editable-container';
 if (!isEditable) { ;
__p += ' not-editable';
 } ;
__p += '">\n        <div class="name-and-times-used">\n            <div class="js-name title editable" contenteditable="' +
__e( isEditable ) +
'"/>\n            ';
 if (timesUsed > 0) { ;
__p += '\n                <span class="times-used" data-content="This image was used ' +
__e( timesUsed ) +
' times">(' +
__e( timesUsed ) +
')</span>\n            ';
 } ;
__p += '\n        </div>\n        ';
 if (isEditable) { ;
__p += '\n            <div class="editable-cell-img"><div class="editable-img"></div></div>\n        ';
 } ;
__p += '\n    </div>\n    <div class="js-alt-text-editable-container editable-container';
 if (!isEditable) { ;
__p += ' not-editable';
 } ;
__p += '">\n        <div class="alt-text-label">Alt text:</div>\n        <div class="js-alt-text alt-text editable" contenteditable="' +
__e( isEditable ) +
'"></div>\n        ';
 if (isEditable) { ;
__p += '\n            <div class="editable-cell-img js-alt-text-icon"><div class="editable-img"></div></div>\n        ';
 } ;
__p += '\n    </div>\n    <div class="description">\n        <ul>\n            <li>Size: ' +
__e( width ) +
' &times; ' +
__e( height ) +
' / ' +
__e( displaySize ) +
'</li>\n            <li>Type: ' +
__e( extension ) +
'</li>\n            <li>\n                <div class="imageTagsRegion"></div>\n            </li>\n        </ul>\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/projects/image/ProjectImageView.tpl
// module id = 1244
// module chunks = 0